export const life = {
  mounted(){
    this.methods('updateUserInfo');
  }
};
export const event = {
  downloadHelp(){
    window.open('/static/高速公路省界门架数据分析终端软件系统使用说明书.pdf')
  },
  // 取消修改密码
  cancelClick(){
    this.methods('toggleDialog')
  },
  // 确认修改密码
 async confirmClick(){
    await this.methods('updateUser');
    this.methods('toggleDialog')
  },
  // 点击用户名
  clickUserName(){
    // 目前逻辑弹出快捷修改密码
    this.methods('toggleDialog')
  },
  // 点击退出
  async logout() {
    const confirm = await this.$confirm('确定登出系统？', '登出确认', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
    });
    if (confirm === 'confirm') {
      this.methods('logout')
    }
  }
};
